import { computed, defineComponent, useAttrs, toRefs, inject } from "vue";
import { useFormItemCheck } from "../hook";
import "./input.less";
import { FormInjectionKey } from "../const";

export default defineComponent({
  name: "CInput",
  props: {
    modelValue: {
      type: [String, Number],
    },
    readonly: Boolean,
    suffix: String,
  },
  setup(props, { emit }) {
    const { modelValue, readonly, suffix } = toRefs(props);
    const notifyCheck = useFormItemCheck();
    const form = inject(FormInjectionKey, undefined);
    const attrs = useAttrs();
    const inputAttrs = computed(() => {
      return Object.assign(
        {},
        attrs,
        // 或覆写一些监听器的行为
        {
          // 这里确保组件配合 `v-model` 的工作
          onInput: (e: Event): void => {
            const value = (e.target as HTMLInputElement).value;
            emit("update:modelValue", value);
            notifyCheck(true);
          },
          onBlur: (): void => {
            notifyCheck();
          },
          value: modelValue.value,
          readonly: readonly.value || form?.readonly,
        }
      );
    });

    return () => (
      <div class="c-input-box">
        <input {...inputAttrs.value} class="c-input" />
        {suffix.value ? <div class="c-input-suffix">{suffix.value}</div> : null}
      </div>
    );
  },
});
